
import Aside from "./index";
export default class AsideView extends Aside {}
